export default {
  data() {
    const language_level = [
      {
        key: "流利",
        val: "good"
      },
      {
        key: "一般",
        val: "normal"
      },
      {
        key: "基础",
        val: "poor"
      },
    ];
    return {
      language_level,
    };
  },
  methods: {
    addLanguage() {
      // console.log("addLanguage");
      this.vitaForm.language_row.push({
        language_ids: "",
        spoken: "",
        written: "",
      });
    },
    delLanguage(idx) {
      // console.log("delLanguage");
      if (this.vitaForm.language_row.length === 1) return;
      this.vitaForm.language_row.splice(idx, 1);
    },
    addEducationExp() {
      // console.log("addEducationExp");
      this.vitaForm.academic_qualification.push({
        time: [],
        academic_start_date: "",
        academic_end_date: "",
        academic_address: "",
        academic_venue: "",
        qualification: "",
        references_man: "",
        contact_details: "",
      });
    },
    delEducationExp(idx) {
      // console.log("delEducationExp");
      if (this.vitaForm.academic_qualification.length === 1) return;
      this.vitaForm.academic_qualification.splice(idx, 1);
    },
    addTeaExp() {
      // console.log("addTeaExp");
      this.vitaForm.coaching_Experience.push({
        time: [],
        coach_start_date: "",
        coach_end_date: "",
        coach_address: "",
        coach_team: "",
        coach_position: "",
        coach_references: "",
        coach_contact_details: "",
      });
    },
    delTeaExp(idx) {
      // console.log("delTeaExp");
      if (this.vitaForm.coaching_Experience.length === 1) return;
      this.vitaForm.coaching_Experience.splice(idx, 1);
    },
    addSportExp() {
      // console.log("addSportExp");
      this.vitaForm.playing_experience.push({
        time: [],
        play_start_date: "",
        play_end_date: "",
        play_address: "",
        play_team: "",
        play_team_level: "",
        play_references: "",
        play_contact_details: "",
      });
    },
    delSportExp(idx) {
      // console.log("delSportExp");
      if (this.vitaForm.playing_experience.length === 1) return;
      this.vitaForm.playing_experience.splice(idx, 1);
    },
    getTime(time) {
      return time.map((t) => {
        const timestamp = new Date(t).getTime();
        return this.$yioks.time(timestamp, false);
      });
    },
    changeEduTime(idx) {
      let time = this.vitaForm.academic_qualification[idx].time;
      if(!time) {
        this.$set(this.vitaForm.academic_qualification[idx], "academic_start_date", "");
        this.$set(this.vitaForm.academic_qualification[idx], "academic_end_date", "");
      } else {
        time = this.getTime(time);
        this.$set(this.vitaForm.academic_qualification[idx], "academic_start_date", time[0]);
        this.$set(this.vitaForm.academic_qualification[idx], "academic_end_date", time[1]);
      }
    },
    changeTeaTime(idx) {
      let time = this.vitaForm.coaching_Experience[idx].time;
      if(!time) {
        this.$set(this.vitaForm.coaching_Experience[idx], "coach_start_date", "");
        this.$set(this.vitaForm.coaching_Experience[idx], "coach_end_date", "");
      } else {
        time = this.getTime(time);
        this.$set(this.vitaForm.coaching_Experience[idx], "coach_start_date", time[0]);
        this.$set(this.vitaForm.coaching_Experience[idx], "coach_end_date", time[1]);
      }
    },
    changeSportTime(idx) {
      let time = this.vitaForm.playing_experience[idx].time;
      if(!time) {
        this.$set(this.vitaForm.playing_experience[idx], "play_start_date", "");
        this.$set(this.vitaForm.playing_experience[idx], "play_end_date", "");
      } else {
        time = this.getTime(time);
        this.$set(this.vitaForm.playing_experience[idx], "play_start_date", time[0]);
        this.$set(this.vitaForm.playing_experience[idx], "play_end_date", time[1]);
      }
    },
  }
};